import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../config';
import '../styles/recepcionstock.css';

const SHELVES = Array.from({ length: 10 }, (_, i) => String(i + 1).padStart(2, '0'));

const RecepcionStock = () => {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [shelf, setShelf] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
    setResult(null);
    setError(null);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!file) {
      setError('Por favor, selecciona un archivo.');
      return;
    }
    if (!shelf) {
      setError('Por favor, selecciona una posición de recepción.');
      return;
    }

    setLoading(true);
    setError(null);
    setResult(null);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('shelf', shelf);

    try {
      const response = await fetch(`${API_BASE}/upload-stock-csv/`, {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`,
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Error al procesar el archivo.');
        return;
      }

      setResult(data);
      setFile(null);
      // Reset file input
      const fileInput = document.querySelector('.recepcion-file-input');
      if (fileInput) fileInput.value = '';
    } catch (err) {
      setError('Error de conexión al servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="recepcion-page">
      <button className="recepcion-back-button" onClick={() => navigate('/init')}>
        &#8592;
      </button>
      <div className="recepcion-container">
        <h1 className="recepcion-title">Ingreso de Stock</h1>

        <form onSubmit={handleSubmit} className="recepcion-form">
          <label className="recepcion-label">Posición de Recepción</label>
          <select
            className="recepcion-select"
            value={shelf}
            onChange={(e) => setShelf(e.target.value)}
          >
            <option value="">Seleccionar posición...</option>
            {SHELVES.map((s) => (
              <option key={s} value={s}>
                RECEPCION-{s}
              </option>
            ))}
          </select>

          <label className="recepcion-label">Archivo CSV / Excel</label>
          <input
            type="file"
            onChange={handleFileChange}
            accept=".csv,.xls,.xlsx"
            className="recepcion-file-input"
          />
          <p className="recepcion-hint">Columnas requeridas: sku, cantidad. Opcional: fecha_vencimiento</p>

          {error && <div className="recepcion-error">{error}</div>}

          <button type="submit" className="recepcion-submit-button" disabled={loading}>
            {loading ? 'Procesando...' : 'Subir Stock'}
          </button>
        </form>

        {result && (
          <div className="recepcion-result">
            <div className="recepcion-result-summary">
              <span className="recepcion-success-count">{result.success_count} exitosos</span>
              {result.error_count > 0 && (
                <span className="recepcion-error-count">{result.error_count} errores</span>
              )}
            </div>
            {result.errors && result.errors.length > 0 && (
              <div className="recepcion-errors-list">
                <h3>Errores:</h3>
                {result.errors.map((err, idx) => (
                  <div key={idx} className="recepcion-error-item">
                    Fila {err.row} - SKU: {err.sku} - {err.error}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default RecepcionStock;
